module.exports = __webpack_public_path__ + "static/img/16.610bf1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/16.png
// module id = ryfL
// module chunks = 0